module.exports = __webpack_public_path__ + "img/world_map.b458aaa3.png";